export enum PdfFormTextTagType {
  TIMING_STATUS = "TIMING_STATUS",
  PACKED_DATE = "PACKED_DATE",
  OID = "OID",
  AUTO_GENERATED_PACKED = "AUTO_GENERATED_PACKED",
  SERVICE_ID = "SERVICE_ID",
  PURPOSE = "PURPOSE",
  PLACE = "PLACE",
  CONTACT_NAME = "CONTACT_NAME",
  CONTACT_BUSINESS_NAME = "CONTACT_BUSINESS_NAME",
  CONTACT_PHONE_NO = "CONTACT_PHONE_NO",
  CONTACT_FULL_NAME = "CONTACT_FULL_NAME",
  AGENT_NAME = "AGENT_NAME",
  AGENT_EMAIL = "AGENT_EMAIL",
  AGENT_PHONE = "AGENT_PHONE",
  NOT_BEFORE = "NOT_BEFORE",
  NOT_AFTER = "NOT_AFTER",
  NUMBER_OF_PACKAGES = "NUMBER_OF_PACKAGES",
  NUMBER_OF_ITEMS = "NUMBER_OF_ITEMS",
  WEIGHT = "WEIGHT",
  SIZE = "SIZE",
  SERVICE_TIME = "SERVICE_TIME",
  ACTUAL_NOT_BEFORE = "ACTUAL_NOT_BEFORE",
  ACTUAL_NOT_AFTER = "ACTUAL_NOT_AFTER",
  ACCOUNT_NAME = "ACCOUNT_NAME",
  ACCOUNT_PHONE_NUMBER = "ACCOUNT_PHONE_NUMBER",
  CURRENT_DATE = "CURRENT_DATE"
}
